export default {
  storyboardScreens: [
    {
      imageFile: "02a_marketing.jpg",
      title: "Marketing Offer",
      text:
        "Click NEXT to learn how segmentation capabilities can help you engage with a compelling offer when your customer is considering purchase.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "OF02a",
      hasNext: true,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "02b_marketing.jpg",
      title: "Segmentation",
      text:
        'Maria selects the 70,286 customers who have registered on the web, then selects “Opt-in" to ensure the target group only contains people who have given email permissions.',
      coordinates: { left: "24", top: "457", right: "773", bottom: "178" },
      screenId: "OF02b",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02d_marketing.jpg",
      title: "Segmentation",
      text: "A total of 56,012 customers have opted in to receive emails.",
      coordinates: { left: "14", top: "584", right: "773", bottom: "50" },
      screenId: "OF02c",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02e_marketing.jpg",
      title: "Segmentation",
      text:
        "With the help of machine learning, Maria can optimize the target group by selecting the customers with the highest propensity to make a purchase.",
      coordinates: { left: "777", top: "497", right: "47", bottom: "61" },
      screenId: "OF02e",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02f_marketing.jpg",
      title: "Segmentation",
      text:
        "She selects the top 3 decile groups, which reduces the group to 52,643 customers.",
      coordinates: { left: "15", top: "551", right: "773", bottom: "81" },
      screenId: "OF02f",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02g_marketing.jpg",
      title: "Segmentation",
      text:
        "She wants to target customers with interests relevant to the campaign. SAP pulls in customer data from various sources and displays a tag cloud.",
      coordinates: { left: "523", top: "540", right: "374", bottom: "59" },
      screenId: "OF02g",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02h_marketing.jpg",
      title: "Segmentation",
      text:
        "Maria selects the “dress” tag to reach customers with a love for dresses.",
      coordinates: { left: "273", top: "451", right: "705", bottom: "184" },
      screenId: "OF02h",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02i_marketing.jpg",
      title: "Segmentation",
      text: "This whittles the target group down to 12,091.",
      coordinates: { left: "531", top: "340", right: "391", bottom: "257" },
      screenId: "OF02i",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02j_marketing.jpg",
      title: "Segmentation",
      text:
        "Maria decides to target customers who live near one of Lucia+Daniel's NY locations.",
      coordinates: { left: "714", top: "460", right: "35", bottom: "138" },
      screenId: "OF02j",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02k_marketing.jpg",
      title: "Segmentation",
      text:
        "Based on this geolocation criteria, 2,561 customers are left in the target group.",
      coordinates: { left: "504", top: "261", right: "423", bottom: "340" },
      screenId: "OF02k",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02l_marketing.jpg",
      title: "Segmentation",
      text: 'Maria saves the target group, naming it "NYC Dresses”.',
      coordinates: { left: "605", top: "349", right: "315", bottom: "287" },
      screenId: "OF02l",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "02m_marketing.jpg",
      title: "Campaign Designer",
      text:
        "Now let’s take a look at the email campaign design. By clicking on Fall Campaign, Maria can see the overview and details on the right.",
      coordinates: { left: "243", top: "259", right: "599", bottom: "310" },
      screenId: "OF02m",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "02n_marketing.jpg",
      title: "Campaign Designer",
      text:
        "By selecting the target group, Maria can view details and insights on the customers within.",
      coordinates: { left: "364", top: "260", right: "479", bottom: "311" },
      screenId: "Of02n",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "02o_marketing.jpg",
      title: "Campaign Designer",
      text:
        "The first email will go to customers who live outside of a 40-mile radius of a NY store location. It will promote the rose petal dress and point them to the website.",
      coordinates: { left: "728", top: "74", right: "15", bottom: "535" },
      screenId: "OF02o",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "02p_marketing.jpg",
      title: "Campaign Designer",
      text:
        "Maria sets up a trigger to check inventory on the rose petal dress for those customers who live near the stores in NYC.",
      coordinates: { left: "731", top: "115", right: "11", bottom: "495" },
      screenId: "OF02p",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "02q_marketing.jpg",
      title: "Campaign Designer",
      text:
        "If there is inventory, the email with the rose petal dress image is sent with a link to make an in-store appointment with a sales rep.",
      coordinates: { left: "864", top: "330", right: "60", bottom: "295" },
      screenId: "OF02q",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "02r_marketing.jpg",
      title: "Campaign Designer",
      text:
        "If there is no inventory available, the Next Best Product Recommendation Engine suggests the most relevant dress for that particular customer. In this case, a black dress.",
      coordinates: { left: "765", top: "262", right: "174", bottom: "279" },
      screenId: "OF02r",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "02s_marketing.jpg",
      title: "Campaign Designer",
      text: "Maria reviews the information again and starts the campaign.",
      coordinates: { left: "934", top: "8", right: "50", bottom: "620" },
      screenId: "OF02s",
      hasNext: false,
      highlightPosition: "Top-Left"
    }
  ]
};
